import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const outcomeImporterSelectors = importerSelectors(
  'outcome.importer',
);

export default outcomeImporterSelectors;
